import { updateTaskTiming, getTaskCalendar } from '../../../assets/js/events/utils/index';
function onBeforeTaskUpdate(id) {
  const gantt = window.to_use_react_gantt;
  gantt.iscritical_init = false;

  updateTaskWorkingHours();

  function updateTaskWorkingHours() {
    if(!gantt.shouldAdjustWorkingHours) return
    const task = gantt.getTask(id);
    if(task.type === 'milestone') return
    const calendar = getTaskCalendar(task, gantt);
    let hours_start =
      calendar?._worktime.dates[
        task.start_date.getDay() - 1 < 0
          ? 6
          : task.start_date.getDay() - 1
      ];
    if (hours_start) {
      hours_start = hours_start[0]?.split('-')[0];
    }
    const task_start = new Date(task.start_date);
    task_start.setHours(hours_start);

    let hours_end =
      calendar?._worktime.dates[
        task.end_date.getDay() - 1 < 0 ? 6 : task.end_date.getDay() - 1
      ];
    if (hours_end) {
      hours_end = hours_end[hours_end?.length - 1]?.split('-')[1];
    }
    const task_end = new Date(task.end_date);
    task_end.setHours(hours_end);
    // If the start_date or end_date time differs from the calculated time, the updateTaskTiming function is executed.
    if (
      task_start.getHours() !== task.start_date.getHours() ||
      task_end.getHours() !== task.end_date.getHours()
    ) {
      task.start_date = new Date(task.start_date.toDateString());
      task.end_date = new Date(
        task.end_date.toDateString() + ' 23:59:59'
      );
      updateTaskTiming({ task, gantt });
    }
  }

}

export { onBeforeTaskUpdate };